import React from "react";
import MainBanner from "../../assets/product/ourproductbg.png";
import Icon from "../../assets/icon-1.svg";
import HotelBooking from "../../assets/product/hotel.png";
import HotelBookingIcon from "../../assets/product/hotelbookingicon.svg";
import Cloud from "../../assets/icon/could.svg";
import Mice from "../../assets/product/mice.png";
import MiceIcon from "../../assets/product/miceicon.svg";
import Wedding from "../../assets/product/wedding.png";
import WeddingIcon from "../../assets/product/weddingicon.svg";
import InboundTour from "../../assets/product/inboundtour.png";
import InboundTourIcon from "../../assets/product/inboundtouricon.svg";
import Visa from "../../assets/product/visa.png";
import VisaIcon from "../../assets/product/visaicon.svg";
import Event from "../../assets/product/eventmanage.png";
import EventIcon from "../../assets/product/eventmanageicon.svg";
import Transportation from "../../assets/product/transportation.png";
import TransportationIcon from "../../assets/product/transportationicon.svg";
import GroupTour from "../../assets/product/grouptour.png";
import GroupTourIcon from "../../assets/product/grouptouricon.svg";
import SightSeeing from "../../assets/product/sightseeing.png";
import SightSeeingIcon from "../../assets/product/sightseeingicon.svg";
import Playstore from "../../assets/icon/googlepay.svg";
import Appstore from "../../assets/icon/appstore.svg";
import QrCode from "../../assets/icon/qrcode.svg";
import ManTarvel from "../../assets/icon/man-traveling.svg";
import Mobile from "../../assets/icon/mobile.png";

function OurProducts() {
  return (
    <div>
      <div className="sectionbg">
        <div className="container mx-auto p-5 md:px-8 lg:px-15">
          <div className="flex gap-5 flex-col justify-center py-10">
            <h1 className="font-bold text-center font-primary text-[40px] leading-[30px]">
              Our Products
            </h1>
            <p className="font-primary text-xl text-center font-bold inter">
            Your Adventure Awaits!
            </p>
            <div className="flex justify-center items-center">
              <img src={MainBanner} alt="fbt-b2b" />
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto my-4 p-5 md:p-8 md:my-10 lg:px-15">
        <div className="flex flex-col md:items-center">
          <span className="flex gap-2 items-baseline justify-start md:justify-center my-1 text-black">
            <img src={Icon} alt="fbt-b2b" />
            <h2 className="font-primary font-bold text-xl sm:text-2xl">
            One Stop Solution for Travel Partners
            </h2>
          </span>
          <h1 className="font-semibold w-full mt-5 mb-0 text-center text-2xl sm:text-4xl md:mb-10 md:3/4">
          Your All-in-One Hub for Comprehensive Travel Partnerships and Services
          </h1>
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-3">
            <div className="flex gap-2 flex-col items-center p-3">
            <div class="hover01 column">
              <div>
                <figure>
              <span className="flex gap-2 items-center justify-center my-1 text-black">
                <img src={HotelBooking} alt="fbt-b2b" />
              </span>
              </figure></div></div>
              <span className="flex gap-2 items-center justify-center my-3 font-primary">
                <img src={HotelBookingIcon} alt="fbt-b2b" />
                <h2 className="font-primary font-bold text-lg sm:text-xl">
                  Hotels Booking
                </h2>
              </span>
              <p className="text-center font-bold text-base font-[#000929]">
              Effortless Hotel Booking, Anytime, Anywhere
              </p>
            </div>
            <div className="flex gap-2 flex-col items-center p-3">
            <div class="hover01 column">
              <div>
                <figure>
              <span className="flex gap-2 items-center justify-center my-1 text-black">
                <img src={Mice} alt="fbt-b2b" />
              </span>
              </figure></div></div>
              <span className="flex gap-2 items-center justify-center my-3 font-primary">
                <img src={MiceIcon} alt="fbt-b2b" />
                <h2 className="font-primary font-bold text-lg sm:text-xl">
                  MICE
                </h2>
              </span>
              <p className="text-center font-bold text-base font-[#000929]">
              Optimized Solutions for MICE Events.
              </p>
            </div>
            <div className="flex gap-2 flex-col items-center p-3">
            <div class="hover01 column">
              <div>
                <figure>
              <span className="flex gap-2 items-center justify-center my-1 text-black">
                <img src={Wedding} alt="fbt-b2b" />
              </span>
              </figure></div></div>
              <span className="flex gap-2 items-center justify-center my-3 font-primary">
                <img src={WeddingIcon} alt="fbt-b2b" />
                <h2 className="font-primary font-bold text-lg sm:text-xl">
                  Weddings
                </h2>
              </span>
              <p className="text-center w-3/4 font-bold text-base font-[#000929]">
              Perfect Solutions for Your Dream Wedding Arrangements.
              </p>
            </div>
            <div className="flex gap-2 flex-col items-center p-3">
            <div class="hover01 column">
              <div>
                <figure>
              <span className="flex gap-2 items-center justify-center my-1 text-black">
                <img src={InboundTour} alt="fbt-b2b" />
              </span></figure></div></div>
              <span className="flex gap-2 items-center justify-center my-3 font-primary">
                <img src={InboundTourIcon} alt="fbt-b2b" />
                <h2 className="font-primary font-bold text-lg sm:text-xl">
                  Inbound Tour
                </h2>
              </span>
              <p className="text-center w-3/4 font-bold text-base font-[#000929]">
              Discover the Best with Our Inbound Tours
              </p>
            </div>
            <div className="flex gap-2 flex-col items-center p-3">
            <div class="hover01 column">
              <div>
                <figure>
              <span className="flex gap-2 items-center justify-center my-1 text-black">
                <img src={Visa} alt="fbt-b2b" />
              </span>
              </figure></div></div>
              <span className="flex gap-2 items-center justify-center my-3 font-primary">
                <img src={VisaIcon} alt="fbt-b2b" />
                <h2 className="font-primary font-bold text-lg sm:text-xl">
                  VISA
                </h2>
              </span>
              <p className="text-center w-3/4 font-bold text-base font-[#000929]">
              Effortless Visa Services for Every Destination.
              </p>
            </div>
            <div className="flex gap-2 flex-col items-center p-3">
            <div class="hover01 column">
              <div>
                <figure>
              <span className="flex gap-2 items-center justify-center my-1 text-black">
                <img src={Event} alt="fbt-b2b" />
              </span>
              </figure></div></div>
              <span className="flex gap-2 items-center justify-center my-3 font-primary">
                <img src={EventIcon} alt="fbt-b2b" />
                <h2 className="font-primary font-bold text-lg sm:text-xl">
                  Event Management
                </h2>
              </span>
              <p className="text-center w-3/4 font-bold text-base font-[#000929]">
              Effortless Planning for Unforgettable Events
              </p>
            </div>
            <div className="flex gap-2 flex-col items-center p-3">
            <div class="hover01 column">
              <div>
                <figure>
              <span className="flex gap-2 items-center justify-center my-1 text-black">
                <img src={Transportation} alt="fbt-b2b" />
              </span>
              </figure></div></div>
              <span className="flex gap-2 items-center justify-center my-3 font-primary">
                <img src={TransportationIcon} alt="fbt-b2b" />
                <h2 className="font-primary font-bold text-lg sm:text-xl">
                  Transportation
                </h2>
              </span>
              <p className="text-center w-3/4 font-bold text-base font-[#000929]">
              Reliable Transportation for Every Journey
              </p>
            </div>
            <div className="flex gap-2 flex-col items-center p-3">
            <div class="hover01 column">
              <div>
                <figure>
              <span className="flex gap-2 items-center justify-center my-1 text-black">
                <img src={GroupTour} alt="fbt-b2b" />
              </span>
              </figure></div></div>
              <span className="flex gap-2 items-center justify-center my-3 font-primary">
                <img src={GroupTourIcon} alt="fbt-b2b" />
                <h2 className="font-primary font-bold text-lg sm:text-xl">
                  Group Tour
                </h2>
              </span>
              <p className="text-center w-3/4 font-bold text-base font-[#000929]">
              Memorable Experiences for Every Group Adventure
              </p>
            </div>
            <div className="flex gap-2 flex-col items-center p-3">
            <div class="hover01 column">
              <div>
                <figure>
              <span className="flex gap-2 items-center justify-center my-1 text-black">
                <img src={SightSeeing} alt="fbt-b2b" />
              </span>
              </figure></div></div>
              <span className="flex gap-2 items-center justify-center my-3 font-primary">
                <img src={SightSeeingIcon} alt="fbt-b2b" />
                <h2 className="font-primary font-bold text-lg sm:text-xl">
                  Sightseeing & Activities
                </h2>
              </span>
              <p className="text-center w-3/4 font-bold text-base font-[#000929]">
              Unforgettable Sightseeing Adventures Await
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="sectionbg relative my-0 md:my-10">
        <img src={Cloud} alt="fbtb2b" className="absolute top-[5%] left-[50%]" />
        <img src={Cloud} alt="fbtb2b" className="absolute top-[12%] left-[30%]" />
        <img src={Cloud} alt="fbtb2b" className="absolute top-[2%] left-[10%]" />
        <img
          src={Cloud}
          alt="fbtb2b"
          className="absolute top-[5%] left-[80%] hidden md:block"
        />
        <div className="container mx-auto p-5 md:px-8 lg:px-15">
          <div className="py-10 flex flex-col justify-between lg:flex-row">
            <div className="w-full flex flex-col gap-1 lg:w-2/5">
              <div className="font-semibold font-primary text-base mb-3 text-center md:text-left">
                Get all your trip detail in our Mobile App
              </div>
              <div className="font-semibold font-primary text-3xl mb-3 text-center md:text-left">
              <span className="text-[rgb(24,119,242)]">Journey<span className="text-[#e51e25]">X</span></span> the one stop destination for all your trip worries
              </div>
              <div className="flex flex-wrap flex-col items-center justify-center gap-5 my-5 sm:flex-row md:justify-start">
                <div class="hover01 column">
                  <div>
                    <figure>
                      <img
                        src={Appstore}
                        className="max-w-48 w-full"
                        alt="fbt-b2b"
                      />
                    </figure>
                  </div>
                </div>
                <div class="hover01 column">
                  <div>
                    <figure>
                      <img
                        src={Playstore}
                        className="max-w-48 w-full"
                        alt="fbt-b2b"
                      />
                    </figure>
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-center gap-5 my-5 justify-center md:justify-start md:flex-row">
                <img src={QrCode} alt="fbt-b2b" />
                <div className="font-semibold font-primary text-lg mb-3 text-center md:text-left ">
                  Scan the QR code to install JourneyX Mobile App
                </div>
              </div>
            </div>
            <div className="relative flex w-full lg:w-[60%] justify-center pt-10 md:justify-end lg:pt-0">
              <img
                src={ManTarvel}
                alt="fbt-b2b"
                className="absolute z-10 left-[-120px] top-[15%] hidden md:block"
              />
              <div className="relative">
                <img
                  src={Mobile}
                  alt="fbt-b2b"
                  className="max-w-[529px] w-full"
                />
                {/* <img src={Shadow} alt="fbt-b2b" className="absolute bottom-[-20%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 hidden md:block lg:bottom-[-5%]"/> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurProducts;
